
import emailjs from 'emailjs-com';

// const sender = {
//     service: 'gmail',
//     auth: {
//         user: 'developeravicia@gmail.com',
//         pass: process.env.REACT_APP_PASSWORD,
//         service_id: process.env.REACT_APP_SERVICEID,
//         template_id: process.env.REACT_APP_SERVICEID,
//     }
// }
export default function sendNodeMail(fromname, fromemail, phone, message, cogoToast) {
  var params = {
    fromname: fromname,
    fromemail: fromemail,
    toname: 'Steven',
    toemail: 'stevenfernz96@gmail.com',
    phone: phone,
    message: message,
    replyTo: fromemail
  };

  // console.log('Message sent', '\n' + fromName);
  // console.log(fromEmail);
  // console.log(message);
  // console.log(sender.service_id);
  // console.log(sender.template_id);
  // emailjs.send(sender.service_id, sender.template_id, params)
  emailjs.send('service_l42ky5r', 'template_wusg43f', params)
    .then(function (response) {
      cogoToast.success("Thank you! I'll get back as soon as possible", { position: 'top-center', heading: 'Mail Sent!' });
      console.log('SUCCESS!', response.status, response.text);
    }, function (error) {
      cogoToast.success("You can also mail me by clicking on GMAIL from the footer", { position: 'top-center', heading: 'Oops! Something went wrong' });
      console.log('FAILED...', error);
    })


}